/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
import { useNamespace, useStripes } from '@folio/stripes/core';
import { useQueries } from 'react-query';
import { groupBy } from 'lodash';
import useTenantKy from './useTenantKy';

export default function useItems(holdings) {
  const {
    okapi: { tenant },
  } = useStripes();

  const ky = useTenantKy({ tenantId: tenant });
  const [namespace] = useNamespace({ key: 'item' });

  const holdingsItems = useQueries(
    holdings && holdings.length
      ? holdings.map((holding) => {
          return {
            enabled: Boolean(holding.id),
            queryKey: [namespace, holding.id, tenant],
            queryFn: () =>
              ky
                .get(
                  `inventory/items?limit=5000&query=(holdingsRecordId==${holding.id})`,
                )
                .json(),
          };
        })
      : [],
  );

  const items = holdingsItems
    .map(({ data }) => data?.items)
    .filter(Boolean)
    .flat();

  // Create a function to refetch all items
  const refetchAllItems = () => {
    return Promise.all(
      holdingsItems.map(({ refetch }) => refetch())
    );
  };

  return {
    items: groupBy(items, 'holdingsRecordId'),
    isItemsLoading: holdingsItems.some(({ isFetching }) => isFetching),
    refetchAllItems,
  };
}
